/* @generated */

// src/assets/ui-icon/line/notification-off.tsx
import * as React from "react";
var NotificationOffLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m17.608 12.97-.329-.22a1.746 1.746 0 0 1-.75-1.137l-1.17 1.17.025.046c.252.471.618.873 1.063 1.17l.329.218a2.744 2.744 0 0 1 1.177 1.781h-5.81l-2.095 2.096a1.865 1.865 0 0 0 .49.867 1.858 1.858 0 0 0 1.462.538 1.857 1.857 0 0 0 2-2h5.5v-.993a4.241 4.241 0 0 0-1.892-3.537Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.94 20.081-1-1L6.521 17.5H4.5v-.993a4.24 4.24 0 0 1 1.893-3.539l.327-.219a1.746 1.746 0 0 0 .78-1.454V9.622c0-1.093 0-2.331.563-3.336.676-1.203 1.965-1.787 3.937-1.787 1.972 0 3.26.584 3.937 1.788.234.417.37.875.45 1.346l2.694-2.694 1 1L5.94 20.081Zm8.69-13.06c.294.524.355 1.25.367 2.003l-6.975 6.975H6.047a2.743 2.743 0 0 1 1.178-1.782l.328-.219A3.244 3.244 0 0 0 9 11.294V9.621c0-.953 0-1.938.37-2.6.248-.438.789-1.022 2.63-1.022 1.841 0 2.383.584 2.63 1.023Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  NotificationOffLine
};
